module.exports = __webpack_public_path__ + "img/043.1312be62.png";